// src/Announcements.js
import React, { useEffect, useState } from "react";
import "./Announcements.css";

const BWC_BASE_URL = "https://bwc-prod.innovateherhacks.org";

// cdef is a JSON string from the API that we parse
function parseCdef(cdef) {
  // Backend actually uses double-quoted JSON; guide shows single quotes.
  // If your instance really returns single quotes, normalize them here.
  const normalized = cdef.replace(/'/g, '"');
  return JSON.parse(normalized);
}

function Announcements({ accessToken }) {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchAnnouncements() {
      try {
        setLoading(true);
        setError(null);

        const res = await fetch(
          BWC_BASE_URL + "/api/v1/l4/pannounce/announce",
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        //);
        ).catch((e) => {
  console.error("Network error:", e);
  throw e;
});

        if (!res.ok) {
          const text = await res.text();
          throw new Error(
            "Failed to load announcements: " + res.status + " " + text
          );
        }

        const data = await res.json();
        const list = Object.values(data).sort(
          (a, b) => b.published_at - a.published_at
        );

        setAnnouncements(list);
      } catch(err) {
        setError(err.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    }

    if (accessToken) {
      fetchAnnouncements();
    }
  }, [accessToken]);

  if (!accessToken) {
    return (
      <div className="announcements-container">
        <div className="announcements-inner">
          <h1>ANNOUNCEMENTS</h1>
          <p>Please log in to view announcements.</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="announcements-container">
        <div className="announcements-inner">
          <h1>ANNOUNCEMENTS</h1>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="announcements-container">
        <div className="announcements-inner">
          <h1>ANNOUNCEMENTS</h1>
          <p style={{ color: "#ffb3b3" }}>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="announcements-container">
      <div className="announcements-inner">
        <h1>ANNOUNCEMENTS</h1>
        {announcements.length === 0 ? (
          <p>No announcements yet.</p>
        ) : (
          <ul className="announcements-list">
            {announcements.map((a) => {
              const c = parseCdef(a.cdef);
              const publishedDate = new Date(a.published_at * 1000);

              return (
                <li key={a.id} className="announcement-card">
                  <h2>{c.title}</h2>
                  {c.author && (
                    <p className="announcement-meta">
                      By {c.author} - {publishedDate.toLocaleString()}
                    </p>
                  )}
                  <div className="announcement-body">{c.body}</div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Announcements;
